import { render } from "./EditAssistanceNoteInvoice.vue?vue&type=template&id=a28affe6&scoped=true"
import script from "./EditAssistanceNoteInvoice.vue?vue&type=script&lang=js"
export * from "./EditAssistanceNoteInvoice.vue?vue&type=script&lang=js"

import "./EditAssistanceNoteInvoice.vue?vue&type=style&index=0&id=a28affe6&lang=css"
import "./EditAssistanceNoteInvoice.vue?vue&type=style&index=1&id=a28affe6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a28affe6"]])

export default __exports__